var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_26199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 2.66699C9.13935 2.66699 3.16602 8.64033 3.16602 16.0003C3.16602 23.3603 9.13935 29.3337 16.4993 29.3337C23.8593 29.3337 29.8327 23.3603 29.8327 16.0003C29.8327 8.64033 23.8593 2.66699 16.4993 2.66699ZM16.4993 4.00033C23.1127 4.00033 28.4993 9.38699 28.4993 16.0003C28.4993 17.8937 28.046 19.6803 27.2593 21.2803C25.2193 18.987 21.9527 17.427 17.4193 17.2403C19.926 16.8003 21.8327 14.627 21.8327 12.0003C21.8327 9.05366 19.446 6.66699 16.4993 6.66699C13.5527 6.66699 11.166 9.05366 11.166 12.0003C11.166 14.627 13.0727 16.8003 15.5793 17.2403C11.046 17.427 7.77935 18.987 5.73935 21.2803C4.95268 19.6803 4.49935 17.8937 4.49935 16.0003C4.49935 9.38699 9.88601 4.00033 16.4993 4.00033ZM12.4993 12.0003C12.4993 9.80032 14.2993 8.00033 16.4993 8.00033C18.6993 8.00033 20.4993 9.80032 20.4993 12.0003C20.4993 14.2003 18.6993 16.0003 16.4993 16.0003C14.2993 16.0003 12.4993 14.2003 12.4993 12.0003ZM16.4993 28.0003C12.286 28.0003 8.57935 25.8137 6.43268 22.507C8.51268 19.907 11.9793 18.5337 16.4993 18.5337C21.0193 18.5337 24.486 19.907 26.566 22.507C24.4193 25.8137 20.7127 28.0003 16.4993 28.0003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9815_26199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.945312)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogo);
export default __webpack_public_path__ + "static/media/profileLogo.4337a39d2bb39988077dbd54f9cdc73c.svg";
export { ForwardRef as ReactComponent };